import dayjs from 'dayjs';
import {
  ComposedChartDataItem,
  LineChartDataItem,
} from 'plume-ui/dist/utils/charts/chartTypes';
import { SHORT_DATE_TIME_FORMAT } from '../../../config';

export const generateFakeChartData = (
  pointCount = 24,
  maxValue = 100,
  minValue = 0,
): ComposedChartDataItem[] => {
  const data: ComposedChartDataItem[] = [];
  const date = dayjs();

  for (let i = 0; i < pointCount; i++) {
    const newDate = date.subtract(pointCount - i, 'hour').minute(0);

    data.push({
      name: newDate.format(SHORT_DATE_TIME_FORMAT),
      values: [Math.floor(Math.random() * (maxValue - minValue)) + minValue],
    });
  }

  return data;
};

export const generateDNSChartData = (pointCount = 24) => {
  const data: ComposedChartDataItem[] = [];
  const date = dayjs();
  const maxBackgroundValue = 1000;

  for (let i = 0; i < pointCount; i++) {
    const newDate = date.subtract(pointCount - i, 'hour').minute(0);

    data.push({
      name: newDate.format(SHORT_DATE_TIME_FORMAT),
      values: [
        i > pointCount - 4
          ? 20311
          : Math.floor(Math.random() * maxBackgroundValue),
      ],
    });
  }

  return data;
};

export const generateFakeLineChartData = (
  pointCount = 24,
  maxValue = 100,
  minValue = 0,
): LineChartDataItem => {
  const data: LineChartDataItem = [];
  const date = dayjs();

  for (let i = 0; i < pointCount; i++) {
    const newDate = date.subtract(12 - i, 'hour').minute(0);
    data.push({
      xAxisLabel: newDate.format(SHORT_DATE_TIME_FORMAT),
      value: Math.floor(Math.random() * (maxValue - minValue)) + minValue,
    });
  }

  return data;
};

export const generateDNSLineChartData = (
  pointCount = 24,
): LineChartDataItem => {
  const data: LineChartDataItem = [];
  const date = dayjs();
  const maxBackgroundValue = 1000;

  for (let i = 0; i < pointCount; i++) {
    const newDate = date.subtract(pointCount - i, 'hour').minute(0);
    data.push({
      xAxisLabel: newDate.format(SHORT_DATE_TIME_FORMAT),
      value:
        i > pointCount - 4
          ? 20311
          : Math.floor(Math.random() * maxBackgroundValue),
    });
  }

  return data;
};

export const randomLocationId = () => {
  const length = 24;
  let result = '';
  const characters = '0123456789abcdef';
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return result;
};
